module.exports = __webpack_public_path__ + "fb45e8c3796cc40292f90fc76dbf886a.svg";